import React, { useEffect, useState } from 'react';
import { useParams, Redirect } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import isEmpty from 'lodash/isEmpty';
import { toast } from 'react-toastify';

import { useSearchQuery } from 'hooks/location';
import AxiosClient from 'configurations/api-client';
import { buildApiZoomConnection } from 'constants/api-paths';
import { buildExpertAccountSectionPath } from 'constants/route-paths';
import { accountExpertSections } from 'constants/common';
import { getErrorMessage } from 'utils/message';

const ZoomConnectionCallback = () => {
  const { siteSlug } = useParams();
  const query = useSearchQuery();

  const code = query.get('code');

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!isEmpty(code)) {
      AxiosClient.patch(buildApiZoomConnection(siteSlug), {
        code,
      })
        .then(() => toast.success('Connect to zoom account successfully'))
        .catch((error) => toast.error(getErrorMessage(error.response)))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
      toast.error('Invalid callback url');
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return loading ? (
    <Spinner className='m-auto' animation='border' />
  ) : (
    <Redirect to={buildExpertAccountSectionPath(accountExpertSections.ZOOM_INTEGRATION.href, siteSlug)} />
  );
};

export default ZoomConnectionCallback;
